// extracted by mini-css-extract-plugin
export default {"okay":"sn_okay__QYJOP","bg":"sn_bg__U1YqA","displayN":"sn_displayN__Wfwo1","con":"sn_con__iZrBb","h":"sn_h__uV78j","b":"sn_b__Byxiu"};